<template>
  <footer class="footer-section">
    <!-- 상단: 프로모션 배너 -->
    <div class="promo-banner">
      <div class="promo-content">
        <div class="promo-left">
          <span class="promo-tag">CHEONGJU NEW TOWN</span>
          <h3 class="promo-title">청주 테크노폴리스의 중심!</h3>
          <p class="promo-sub">SK하이닉스 배후 프리미엄 대단지</p>
        </div>
        <div class="promo-divider"></div>
        <div class="promo-right">
          <p class="promo-benefit">1,812세대 대단지 프리미엄</p>
          <p class="promo-benefit highlight">직주근접 신도시 생활권</p>
        </div>
      </div>
    </div>

    <!-- 중간: 메인 정보 영역 -->
    <div class="footer-main">
      <div class="footer-inner">
        <!-- 좌측: 브랜드 & 전화번호 -->
        <div class="footer-brand">
          <div class="brand-logo">
            <span class="logo-main">청주 레이원시티</span>
            <span class="logo-sub">홍보관 상담센터</span>
          </div>
          <a href="tel:1666-6818" class="footer-phone">
            <span class="phone-label">대표문의</span>
            <span class="phone-number">1666-6818</span>
          </a>
        </div>

        <!-- 우측: 정보 그리드 -->
        <div class="info-grid">
          <div class="info-item full-width">
            <span class="info-label">현장위치</span>
            <span class="info-value">청주시 흥덕구 송절동 산 76-2번지 일원</span>
          </div>
          <div class="info-item">
            <span class="info-label">홈페이지 운영</span>
            <span class="info-value">주식회사 더한걸음</span>
          </div>
          <div class="info-item">
            <span class="info-label">이메일</span>
            <span class="info-value">info@step1.kr</span>
          </div>
          <div class="info-item">
            <span class="info-label">홈페이지 관련 문의</span>
            <span class="info-value"><a href="tel:1533-9048" class="info-phone">1533-9048</a></span>
          </div>
        </div>
      </div>
    </div>

    <!-- 하단: 면책조항 & 저작권 -->
    <div class="footer-bottom">
      <div class="footer-inner">
        <div class="disclaimers">
          <p>본 사이트는 청주 레이원시티 홍보관 상담센터 정보 제공 페이지입니다.</p>
          <p>※ 본 사이트는 분양 상담 및 방문 예약 안내를 위한 사이트이며, 사업 및 분양과 관련된 자세한 사항은 상담을 통해 안내받으실 수 있습니다.</p>
          <p>본 사이트는 청주 레이원시티 분양 상담 및 방문 예약 안내를 위한 홍보 상담 페이지입니다.</p>
          <p>시행사 및 시공사의 공식 홈페이지가 아니며 상담 안내 서비스를 제공하는 페이지입니다.</p>
          <p>분양 관련 상세 정보는 모델하우스 상담을 통해 안내받으실 수 있습니다.</p>
        </div>
        <div class="copyright">
          <span>Copyright ⓒ 2026 주식회사 더한걸음. All rights reserved.</span>
          <router-link to="/privacy" class="privacy-link">개인정보처리방침</router-link>
        </div>
      </div>
    </div>

    <!-- 워터마크 -->
    <img src="@/assets/logo/logo_symbol.png" alt="" class="watermark-logo" />
  </footer>
</template>

<script>
export default {
  name: 'FooterSection'
}
</script>

<style scoped>
.footer-section {
  width: 100%;
  height: 100vh;
  background: #0a0a0a;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

/* 워터마크 */
.watermark-logo {
  position: absolute;
  bottom: -15%;
  right: -10%;
  width: 900px;
  height: auto;
  opacity: 0.03;
  pointer-events: none;
  z-index: 0;
}

/* 프로모션 배너 */
.promo-banner {
  flex: 0 0 auto;
  background: linear-gradient(135deg, var(--rayone-primary) 0%, var(--rayone-primary-dark) 100%);
  padding: 60px 0;
  position: relative;
  z-index: 1;
}

.promo-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 80px;
}

.promo-left {
  text-align: right;
}

.promo-tag {
  display: inline-block;
  font-family: var(--font-paperlogy);
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 4px;
  margin-bottom: 16px;
  padding: 8px 16px;
  border: 1px solid rgba(255, 255, 255, 0.4);
}

.promo-title {
  font-family: var(--font-pretendard);
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 10px;
  letter-spacing: -1px;
}

.promo-sub {
  font-family: var(--font-pretendard);
  font-size: 22px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.85);
}

.promo-divider {
  width: 1px;
  height: 100px;
  background: rgba(255, 255, 255, 0.3);
}

.promo-right {
  text-align: left;
}

.promo-benefit {
  font-family: var(--font-pretendard);
  font-size: 17px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.75);
  margin-bottom: 10px;
}

.promo-benefit.highlight {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 0;
}

/* 푸터 메인 - flex: 1로 남은 공간 채움 */
.footer-main {
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
}

.footer-inner {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
}

.footer-main .footer-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 80px;
}

/* 브랜드 영역 */
.footer-brand {
  flex: 0 0 auto;
}

.brand-logo {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 40px;
}

.logo-main {
  font-family: var(--font-pretendard);
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.5px;
}

.logo-sub {
  font-family: var(--font-pretendard);
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 1px;
}

.footer-phone {
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-decoration: none;
  padding: 24px 36px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.footer-phone:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: var(--rayone-primary);
}

.phone-label {
  font-family: var(--font-pretendard);
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.4);
  letter-spacing: 3px;
}

.phone-number {
  font-family: var(--font-paperlogy);
  font-size: 32px;
  font-weight: 700;
  color: var(--rayone-primary-light);
  letter-spacing: 2px;
}

/* 정보 그리드 */
.info-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 28px 80px;
  max-width: 650px;
}

.info-item.full-width {
  grid-column: 1 / -1;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.info-label {
  font-family: var(--font-pretendard);
  font-size: 12px;
  font-weight: 600;
  color: var(--rayone-primary-light);
  letter-spacing: 3px;
  text-transform: uppercase;
}

.info-value {
  font-family: var(--font-pretendard);
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
}

.info-phone {
  font-family: var(--font-paperlogy);
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.3s ease;
}

.info-phone:hover {
  color: var(--rayone-primary-light);
}

/* 푸터 하단 */
.footer-bottom {
  flex: 0 0 auto;
  padding: 30px 0 100px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  position: relative;
  z-index: 1;
}

.footer-bottom .footer-inner {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 40px;
}

.disclaimers {
  flex: 1;
}

.disclaimers p {
  font-family: var(--font-pretendard);
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.3);
  line-height: 1.8;
  margin-bottom: 4px;
}

.disclaimers p:last-child {
  margin-bottom: 0;
}

.copyright {
  flex: 0 0 auto;
}

.copyright span {
  font-family: var(--font-pretendard);
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.4);
  letter-spacing: 1px;
}

.copyright {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}

.privacy-link {
  font-family: var(--font-pretendard);
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: underline;
  text-underline-offset: 3px;
  transition: color 0.3s ease;
}

.privacy-link:hover {
  color: var(--rayone-primary-light);
}
</style>
